import { render } from "./DownwardRedIcon.vue?vue&type=template&id=5bbf8e91"
import script from "./DownwardRedIcon.vue?vue&type=script&lang=js"
export * from "./DownwardRedIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__